import { useDeleteMutation, useGetQuery, usePostMutation, usePutMutation } from 'shared/lib/api';
import { useQueryClient } from '@tanstack/react-query';

import type { CardModel } from '../models';

import { cardRoutes } from './routes';

const getCardsQueryKey = ['cards'];

export const useGetCardsList = () =>
  useGetQuery<CardModel[]>(cardRoutes.app.getCardsList, {
    queryKey: getCardsQueryKey,
  });

export const useDeleteCard = () => {
  const queryClient = useQueryClient();

  return useDeleteMutation(cardRoutes.app.deleteCard, {
    onSuccess: () => queryClient.invalidateQueries(getCardsQueryKey),
  });
};

export const useCreateCard = () => {
  const queryClient = useQueryClient();

  return usePostMutation(cardRoutes.app.createCard, {
    onSuccess: () => queryClient.invalidateQueries(getCardsQueryKey),
  });
};

export const useUpdateCard = () => {
  const queryClient = useQueryClient();

  return usePutMutation<Pick<CardModel, 'isDefault'>, { success: boolean }>(cardRoutes.app.updateCard, {
    onSuccess: () => {
      void queryClient.invalidateQueries(getCardsQueryKey);
    },
  });
};
